import React, { FC, useEffect, useState } from "react";
import AE2Modal from "../../../elements/AE2Modal";
import { API_URL } from "../../../../actions/settings";
import NotificationPopUp from "../../../extras/NotificationPopUp";
import { IonButton, IonItem, IonSelect, IonSelectOption } from "@ionic/react";

interface IProps {
    meter:string,
    openModal:any,
    setOpenModal:any,
    reload:any
};

async function getSelections(token: string) {
  return fetch(`${API_URL}/cost_avoidance/methods`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
      }).catch((error:any) => {
        NotificationPopUp("Error", error.message, "Error Getting Selections")
      });
}

async function saveSelection(token: string, data:any, id: string|null) {
  return fetch(`${API_URL}/cost_avoidance/method/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(data)
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
      }).catch((error:any) => {
        NotificationPopUp("Error", error.message, "Error Getting Selections")
      });
}

const EditAdjustmentMethodModal:FC<IProps> = ({meter,openModal,setOpenModal,reload}) => {
    const [selections,setSelections] = useState([])
    const [updating, setUpdating] = useState(false)
    const [selectedMethod, setSelectedMethod] = useState('')

    useEffect(() => {
        const handleData = async () => {
          const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
          const res = await getSelections(token);
          if(res){
            setSelections(res.data)
          }
        };
    
        handleData();
      }, [meter]);


    const handleSave = async () =>{
        setUpdating(true)
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const data = {
            'method_id':selectedMethod
        }

        const res = await saveSelection(token,data,meter)
        setUpdating(false)
        if(res){
            setOpenModal(false)
            NotificationPopUp("Success", `Cost Avoidance Method Changed`)
            reload()
        }
    }

    return <AE2Modal title="Edit Baseline Adjustment Method" opened={openModal} setOpened={setOpenModal}>
        <div style={{textAlign:'start',color:'white',marginBottom:'3em'}}>
                    <ul>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>None:</span> No Adjustments Made</li>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>Utility Rate Only:</span> Adjust the utility rate only.</li>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>Legacy Weather(Default):</span> Use UBFD method of weather adjustments with base temp of 65F and R&sup2; &gt;50%.</li>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>Pro-Rate Only:</span> Pro-rate month by month.</li>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>Advanced Weather:</span> Use regression analysis to select base temp and make adjustments.</li>
                        <li style={{paddingBottom:'1em'}}><span style={{fontWeight:'bold'}}>Disabled:</span> Meter will not be used for cost avoidance calculations.</li>
                    </ul>
                </div>
          <div style={{color:'white'}}>
                <div style={{width:'100%',textAlign:"center"}}>                
                <IonItem lines="none" style={{width:'100%'}}>
                    <IonSelect label="Adjustment Method" value={selectedMethod} onIonChange={e => setSelectedMethod(e.detail.value!)}>
                        {selections.map((item:any)=>{
                            return <IonSelectOption key={item.uuid} value={item.uuid}>{item.name}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonButton disabled={updating} onClick={()=>handleSave()} >{updating ? 'Saving ...' : 'Save'}</IonButton>
                </div>
            </div>
        </AE2Modal>
};

export default EditAdjustmentMethodModal;